import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import FeedbackService from 'services/FeedbackService';
import AdminFormModal from '../AdminFormModal';
import AdminCard from '../AdminCard';
import { useStyles } from './styles';
import EditAdminFormModal from '../EditAdminFormModal';

const initialData = {
  page: 1,
  perPage: 10,
  total: 0,
  data: [],
};

export default function AdminList() {
  const classes = useStyles();
  const [filters, setFilters] = useState({ approved: undefined });
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState({ ...initialData });
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [activeFeedback, setActiveFeedback] = useState();
  const filterButtons = [
    { label: 'Feedbacks', value: undefined },
    { label: 'Approved', value: true },
    { label: 'Disapproved', value: false },
  ];
  const feedbackService = new FeedbackService();

  async function fetchData(page) {
    try {
      const response = await feedbackService.findAll({
        approved: filters.approved,
        orderDirection: 'DESC',
        page,
        perPage: initialData.perPage,
      });

      setData(response.data);
    } catch (e) {
      console.error(e);
    }
  }

  async function handlePaginationChange(event, newPage) {
    if (newPage !== currentPage) {
      setCurrentPage(newPage);

      await fetchData(newPage);
    }
  }

  function handleFormModalClose() {
    fetchData(currentPage);

    setFormModalOpen(false);
  }

  useEffect(() => {
    setCurrentPage(1);

    fetchData(1);
  }, [filters]);

  function handleEditModalClose() {
    setActiveFeedback();
    fetchData(currentPage);
  }

  return (
    <>
      <EditAdminFormModal
        open={!!activeFeedback}
        onClose={handleEditModalClose}
        feedback={activeFeedback}
      />

      <AdminFormModal open={formModalOpen} onClose={handleFormModalClose} />

      <Box mb={4} textAlign="center">
        <Typography className={classes.title} variant="h4" gutterBottom={true}>
          Feedback and NPS
        </Typography>

        <Button className={classes.backButton} onClick={() => setFormModalOpen(true)}>
          Add a review
        </Button>
      </Box>

      <Box mb={2}>
        {filterButtons.map((button, index) => (
          <Button
            key={index}
            className={clsx(classes.button, {
              [classes.primaryColor]: filters.approved === button.value,
            })}
            onClick={() => setFilters({ approved: button.value })}
          >
            {button.label}
          </Button>
        ))}
      </Box>

      {data.data.map((feedback, index) => (
        <AdminCard
          key={index}
          feedback={feedback}
          onEditClick={() => setActiveFeedback(feedback)}
          onChange={() => fetchData(currentPage)}
        />
      ))}

      {data.total > initialData.perPage && (
        <Box mt={4}>
          <Pagination
            className={classes.pagination}
            page={currentPage}
            count={Math.ceil(data.total / initialData.perPage)}
            onChange={handlePaginationChange}
          />
        </Box>
      )}
    </>
  );
}
